'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ajax = require('../ajax');

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @desc java的接口 
 */

/** 查询spm,供前端调用，告知前端对应渠道的样式 */
exports.default = {
    // 录入线索接口,
    queryHideDisplayMessageBySpm: function queryHideDisplayMessageBySpm(opts) {
        return _ajax2.default.ajax({
            method: 'post',
            url: '/consumer/v2/indexapi/queryHideDisplayMessageBySpm.json',
            opts: opts
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/souche-spm/dist/api/finance/index.js
// module id = 58kt
// module chunks = 8